import Link from '@commons/components/Link';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import type { DrupalBlock, DrupalLink } from '@commons/types/drupal';

import styles from './index.module.scss';

// Type definition for the Links List block properties.

type Props = DrupalBlock<{
  links?: DrupalLink[];
}>;

/**
 * Links List block component.
 */

const LinksList = ({ content }: Props) => {
  const { links = [] } = content;

  const renderedlinks = links.map((link, index) => {
    const hasURL = link?.url && link?.url !== '#';
    const Item = hasURL ? LinkItem : TextItem;

    return <Item {...link} key={index} />;
  });

  return (
    <Flex
      gap="sm"
      width={12}
      border="top"
      direction="column"
      paddingTop="sm"
      className={styles.wrapper}
    >
      {renderedlinks}
    </Flex>
  );
};

/**
 * LinkItem component.
 */

const LinkItem = ({ url, text }: DrupalLink) => (
  <Flex.Item paddingBottom="sm" border="bottom">
    <Link href={url} level="h6" weight="normal" withArrow="md" className={styles.link}>
      {text}
    </Link>
  </Flex.Item>
);

/**
 * TextItem component.
 *
 * Used when the link URL is empty or '#' as a fallback.
 */

const TextItem = ({ text }: DrupalLink) => (
  <Flex.Item paddingBottom="sm" border="bottom">
    <Text level="h6" weight="normal" marginBottom="none" className={styles.link}>
      {text}
    </Text>
  </Flex.Item>
);

export default LinksList;
